export const CUSTOMER_GROUP_LOADING = "CUSTOMER_GROUP_LOADING";
export const CUSTOMER_GROUP_RESET = "CUSTOMER_GROUP_RESET";
export const GET_CUSTOMER_GROUP = "GET_CUSTOMER_GROUP";
export const GET_CUSTOMER_GROUP_SUCCESS = "GET_CUSTOMER_GROUP_SUCCESS";
export const GET_CUSTOMER_GROUP_FAIL = "GET_CUSTOMER_GROUP_FAIL";
export const DELETE_CUSTOMER_GROUP = "DELETE_CUSTOMER_GROUP"
export const DELETE_CUSTOMER_GROUP_SUCCESS = "DELETE_CUSTOMER_GROUP_SUCCESS"
export const DELETE_CUSTOMER_GROUP_FAIL = "DELETE_CUSTOMER_GROUP_FAIL"
export const UPDATE_CUSTOMER_GROUP = "UPDATE_CUSTOMER_GROUP"
export const UPDATE_CUSTOMER_GROUP_SUCCESS = "UPDATE_CUSTOMER_GROUP_SUCCESS"
export const UPDATE_CUSTOMER_GROUP_FAIL = "UPDATE_CUSTOMER_GROUP_FAIL"
export const ADD_NEW_CUSTOMER_GROUP = "ADD_NEW_CUSTOMER_GROUP"
export const ADD_CUSTOMER_GROUP_SUCCESS = "ADD_CUSTOMER_GROUP_SUCCESS"
export const ADD_CUSTOMER_GROUP_FAIL = "ADD_CUSTOMER_GROUP_FAIL"
export const CUSTOMER_GROUP_RESET_CREATE = "CUSTOMER_GROUP_RESET_CREATE"